var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "timer_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.582,
    height: 27.372,
    viewBox: "0 0 22.582 27.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M32.954,14.415a.847.847,0,1,0-1.2-1.2l-2.4,2.4a11.035,11.035,0,0,0-6.415-2.652V9.711h1.2A.808.808,0,0,0,25,8.855.808.808,0,0,0,24.144,8H19.953a.808.808,0,0,0-.855.855.808.808,0,0,0,.855.855h1.283v3.165a11.628,11.628,0,0,0-6.5,2.652l-2.4-2.4a.847.847,0,1,0-1.2,1.2l2.4,2.4A11.151,11.151,0,0,0,10.8,24.081a11.291,11.291,0,0,0,22.582,0,11.151,11.151,0,0,0-2.737-7.356ZM22.091,33.661a9.58,9.58,0,1,1,0-19.161,9.3,9.3,0,0,1,6.672,2.737h0A9.569,9.569,0,0,1,31.586,24,9.459,9.459,0,0,1,22.091,33.661Z",
    transform: "translate(-10.8 -8)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M24.711,25.446v-4.79a.855.855,0,0,0-1.711,0v5.132a.514.514,0,0,0,.086.342c.086.086.086.171.171.257L26.25,29.38a.827.827,0,0,0,1.2,0,.827.827,0,0,0,0-1.2Z",
    transform: "translate(-12.564 -9.707)",
    fill: "#404040"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer_icon.44c52f689b9579cca964a6a2fffb7fe8.svg";
export { ForwardRef as ReactComponent };